import paths from "constants/paths";

export const fullStoryExceptionPaths = [
    paths.externalAccessLogin, paths.externalAccessDenied, paths.loginCallback
];

export const pendoExceptionPaths = [
    paths.externalAccessDenied, paths.loginCallback
];